import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/invcheck"

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}

// 手工触发审核
export function manualcheck(dto) {
  return request({
    url: prefix + '/manualCheck',
    method: 'post',
    data: dto,
  })
}

// 删除
export function deleterow(id) {
  return request({
    url: prefix + '/delete/' + id,
    method: 'get'
  })
}

// 删除
export function getFiles(id) {
  return request({
    url: prefix + '/getFiles/' + id,
    method: 'get'
  })
}

// 上传文件
export function uploadFile(data) {
  let token = data.get("token")
  let path = prefix + '/uploadFile'
  if(token){
    path = path + "?token=" + token
  }
  return request({
    url: path,
    method: 'post',
    data: data,
    timeout: 300000
  })
}

